export interface IconMap {
  [prop: string]: string;
}

export const productIconMap: IconMap = {
  'Albris': 'AlbrisIcon',
  'ANAFI Work': 'AnafiIcon',
  'Bluegrass Fields': 'BluegrassIcon',
  'Duet M': 'DuetM',
  'eBee AG central body': 'eBeeAg1',
  'eBee BZ': 'ClassicIcon',
  'eBee central body': 'ClassicIcon',
  'eBee Geo': 'eBeeGeo',
  'eBee Plus central body': 'PlusIcon',
  'eBee Plus RTK': 'PlusIcon',
  'eBee Plus': 'PlusIcon',
  'eBee RTK central body': 'RtkIcon',
  'eBee RTK': 'RtkIcon',
  'eBee SQ central body': 'SqIcon',
  'eBee SQ': 'SqIcon',
  'eBee TAC': 'eBeeTac',
  'eBee X': 'EBeeXIcon',
  'eBee': 'ClassicIcon',
  'eBee-Ag-1': 'eBeeAg1',
  'eBee-Ag-2': 'eBeeAg2',
  'emotion3': 'EMotion3Icon',
  'FreeFlight6': 'ParrotIcon',
  'Geobase': 'GeobaseIcon',
  'ParrotFields': 'ParrotIcon',
  'Pix4Dcapture': 'Pix4dMobileIcon',
  'Pix4Dfields': 'Pix4dDesktopIcon',
  'Pix4Dmapper': 'Pix4dDesktopIcon',
  'Pix4DModel': 'Pix4dDesktopIcon',
  'Sequoia +': 'SequoiaIcon',
  'Sequoia': 'SequoiaIcon',
  'SODA': 'SodaIcon',
  'SODA2': 'SodaIcon',
  'Swinglet': 'SwingletIcon',
  'ThermoMap': 'ThermomapIcon',
};



// WEBPACK FOOTER //
// ./src/constants/productIcons.ts